import { getScorers } from '@/utils/statScoreApi';
import i18n from '@/utils/i18n.js';

let settingsScorers = [
  {
    key: 'standing',
  },
  {
    key: 'participantName',
    start: true,
  },
  {
    key: 'team',
    fill: true,
  },
  {
    key: 'goals_scored',
  },
  {
    key: 'goals_per_match',
  },
];

const defaultDataSet = {
  columns: [
    {
      key: 'standing',
      center: true,
      title: '#',
      bordered: true,
    },
    {
      key: 'participantName',
      title: i18n.t('Props.StatScore.Participant Name'),
    },
    {
      key: 'team',
      fill: true,
      title: i18n.t('Props.StatScore.Team'),
    },
    {
      key: 'goal',
      center: true,
      title: '',
    },
  ],
  dataset: [],
  meta: null,
};

const defaultState = {
  scorers: { loading: false, data: [] },
  scorerStandings: [],
  settingsScorers,
};
const state = {
  ...JSON.parse(JSON.stringify(defaultState)),
};

const getters = {};

const mutations = {
  setLoadingStatus(state, data) {
    state.scorers = data.status
      ? { loading: data.status, data: [], error: data.error }
      : { ...state.scorers, loading: false, error: data.error };
  },
  setDefaultState(state) {
    Object.keys(defaultState).forEach(key => {
      state[key] = defaultState[key];
    });
  },
  setScorers(state, data) {
    state.scorers.data = data;
  },
  setScorerStandings(state, data) {
    state.scorerStandings = data;
  },
};

const actions = {
  getScorers: ({ commit, rootState }, payload) => {
    commit('setDefaultState');
    commit('setLoadingStatus', { status: true });
    return new Promise((resolve, reject) => {
      return getScorers({
        selectedLang: rootState.settings.selectedLocale.short_code,
        id: payload,
      })
        .then(res => {
          commit('setScorers', res.data.Data);
          let scorersStandings = res.data.Data
            ? res.data.Data.groups.map(item => {
                let teams = item.participants.map(item => {
                  let otherInformations = {};
                  item.columns.forEach(column => {
                    otherInformations = {
                      ...otherInformations,
                      [column.code]: {
                        title: column.name,
                        short_name: column.short_name,
                        data: { ...column },
                      },
                    };
                  });
                  return {
                    ...otherInformations,
                    standing: { short_name: '#', value: item.rank },
                    participantName: {
                      short_name: i18n.t('Props.StatScore.Participant Name'),
                      value: item.name,
                    },
                    team: {
                      short_name: i18n.t('Props.StatScore.Team'),
                      value: item.subparticipant_name,
                    },
                    zone_name: item.zone_name,
                  };
                });
                return {
                  ...item,
                  teams,
                };
              })
            : [];
          commit('setScorerStandings', scorersStandings);
          commit('setLoadingStatus', { status: false });
          resolve(res);
        })
        .catch(err => {
          reject(err);
          console.log(err);
          commit('setLoadingStatus', { status: false, error: true });
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
